export enum ClipboardTypes {
    Topic = 1,
    Assignment,
    TopicView,
    AssignmentView,
    SearchView,
    TopicUrl,
    AssignmentUrl,
    Story,
    StoryView,
}
